module.exports = __webpack_public_path__ + "static/img/MTZ_04_edit_transp.6f02ee7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/MTZ_04_edit_transp.jpg
// module id = rjf5
// module chunks = 0